"use client";

import { Skeleton } from "@/components/skeleton";
import { cn } from "@/utils/classnames";
import { NavigationBackground } from "./navigation-background";
import { NavigationContainer } from "./navigation-container";
import { NavigationLogo } from "./navigation-logo";
import { NavigationActions } from "./navigation-actions";

type Props = {
  collapsed: boolean;
};

export const NavigationLoading = ({ collapsed }: Props) => {
  return (
    <header>
      {!collapsed ? (
        <NavigationBackground className="bg-white">
          <Skeleton className="h-full w-full" />
        </NavigationBackground>
      ) : null}

      <NavigationContainer collapsed={collapsed}>
        <NavigationLogo
          collapsed={collapsed}
          value="Carregando..."
          loading={true}
        />

        <div
          className={cn({
            "mr-8 hidden md:block": collapsed,
            "flex-1 md:order-0": !collapsed,
          })}
        >
          <Skeleton className="!h-5 !w-30" rounded={true} />
        </div>

        <NavigationActions className="hidden md:flex" collapsed={collapsed}>
          <Skeleton className="!h-12 !w-12" rounded={true} />
        </NavigationActions>
      </NavigationContainer>
    </header>
  );
};
